import { useContext, useEffect, useState } from "react";
import client from "../utils/client";
import { authHeaders } from "../utils/authHeaders";
import { AuthContext } from "../context/authContext";
import useLogout from "./useLogout";

// The status codes /auth/echo answers when the stored session is no good:
// no token, or one the server no longer accepts (isAuthenticated sends 400
// for a missing or bad token, 401 for an unauthorised one).
const STALE_SESSION = [400, 401];

export default function useUser() {
  const [realTimeUser, setRealTimeUser] = useState(null);

  const { user } = useContext(AuthContext);
  const { logout } = useLogout();

  function getUserDetails() {
    client({
      url: `/auth/echo?email=${user.email}`,
      method: "GET",
      headers: authHeaders(),
    })
      .then((res) => {
        setRealTimeUser(res.data.data);
      })
      .catch((err) => {
        // A stale session would otherwise leave the dashboard on its loader
        // forever: clear it and go to the login page instead.
        if (STALE_SESSION.includes(err.response?.status)) {
          logout();
          return;
        }
        console.log(err);
      });
  }

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    realTimeUser,
  };
}
